export const settingsTranslations = {
  fr: {
    title: "Paramètres",
    tabs: {
      profile: "Profil",
      preferences: "Préférences", 
      notifications: "Notifications",
      billing: "Facturation"
    },
    profile: {
      aiPersonalization: "Personnalisation IA",
      aiPersonalizationDesc: "Personnalisez l'assistant IA selon votre profil professionnel",
      changeAvatar: "Changer l'avatar",
      avatarFormats: "Formats acceptés: JPG, PNG, GIF (max 5MB)",
      fullName: "Nom complet",
      email: "Email",
      professionalProfile: "Profil professionnel",
      practiceMode: "Mode d'exercice",
      specialty: "Spécialité",
      service: "Service",
      birthDate: "Date de naissance",
      systemRole: "Rôle système",
      systemRoleDesc: "⚠️ Modification du rôle système réservée aux administrateurs"
    },
    preferences: {
      title: "Préférences",
      subtitle: "Configurez vos préférences d'utilisation",
      language: "Langue",
      theme: "Thème",
      fontSize: "Taille de police",
      defaultView: "Vue par défaut",
      notifications: "Notifications",
      emailNotifications: "Notifications par email",
      studyReminders: "Rappels d'étude",
      communityNotifications: "Notifications communautaires",
      keyboardShortcuts: "Raccourcis clavier",
      keyboardShortcutsDesc: "Activer les raccourcis clavier pour une navigation plus rapide",
      fontSizes: {
        small: "Petite",
        normal: "Normale", 
        large: "Grande"
      },
      defaultViews: {
        list: "Liste",
        cards: "Cartes",
        grid: "Grille"
      }
    },
    themes: {
      light: "Clair",
      dark: "Sombre",
      system: "Système"
    },
    save: {
      saveProfile: "Sauvegarder",
      loadingProfile: "Chargement du profil...",
      profileSuccess: "Profil mis à jour avec succès",
      profileError: "Erreur lors de la mise à jour du profil",
      settingsSuccess: "Paramètres sauvegardés",
      settingsError: "Erreur lors de la sauvegarde des paramètres",
      notificationsEnabled: "Notifications activées avec succès",
      portalError: "Erreur lors de l'ouverture du portail client"
    },
    subscription: {
      currentPlan: "Plan actuel",
      subtitle: "Gérez votre abonnement et votre facturation",
      active: "Abonnement actif",
      inactive: "Abonnement inactif",
      freePremium: "Premium gratuit",
      plan: "Plan",
      trialMessage: "Période d'essai ({{days}} jours restants)",
      expiresOn: "Expire le",
      free: "Gratuit",
      manageSubscription: "Gérer l'abonnement",
      manageDescription: "Modifier votre plan, méthode de paiement et facturation",
      premiumManaged: "Votre compte Premium est géré par l'équipe. Contactez le support pour toute modification.",
      availablePlans: "Plans disponibles",
      monthlyPlan: "Plan Mensuel",
      yearlyPlan: "Plan Annuel",
      popularPlan: "Plus populaire",
      savePercent: "Économisez {{percent}}%",
      features: {
        unlimited: "Accès illimité",
        priority: "Support prioritaire",
        advanced: "Fonctionnalités avancées",
        noAds: "Sans publicité"
      },
      chooseMonthly: "Choisir Mensuel",
      chooseYearly: "Choisir Annuel",
      currentPlanBadge: "Plan actuel",
      billingHistory: "Historique de facturation",
      noInvoices: "Aucune facture disponible",
      invoice: "Facture",
      amount: "Montant",
      status: "Statut",
      date: "Date",
      download: "Télécharger"
    },
    admin: {
      searchUsers: "Rechercher des utilisateurs...",
      refreshUsers: "Actualiser",
      totalUsers: "Total utilisateurs",
      activeUsers: "Utilisateurs actifs", 
      premiumUsers: "Utilisateurs premium",
      trialUsers: "Essais gratuits",
      userManagement: "Gestion des utilisateurs",
      userManagementDesc: "Gérez les comptes utilisateurs, abonnements et accès",
      revenue: "Revenus Abonnements (hors activés manuellement)",
      aiCosts: "Coûts IA (GPT-4.1)",
      netProfit: "Bénéfice Net",
      roiPerUser: "ROI par Utilisateur",
      avgRoiPerUser: "ROI moyen par utilisateur (hors activés manuellement)",
      legitimatePaidUsers: "Utilisateurs payants (légitimes)",
      manuallyActivatedUsers: "Utilisateurs activés manuellement",
      legitimateConversionRate: "Taux de conversion (légitimes)",
      quickActions: "Actions rapides",
      activeSubscribers: 'Abonnés actifs', onTrial: 'En essai', trialExpired: 'Essai expiré',
    },
    professional: {
      student: "Étudiant",
      intern: "Interne",
      resident: "Résident",
      doctor: "Médecin",
      nurse: "Infirmier",
      paramedic: "Paramédical",
      other: "Autre"
    },
    role: {
      user: "Utilisateur",
      moderator: "Modérateur",
      admin: "Administrateur"
    },
    practiceMode: {
      hospital: "Hôpital",
      clinic: "Clinique",
      liberal: "Libéral",
      emergency: "Urgences",
      academic: "Académique",
      other: "Autre"
    },
    specialty: {
      cardiologie: "Cardiologie",
      pneumologie: "Pneumologie",
      nephrologie: "Néphrologie",
      neurologie: "Neurologie",
      endocrinologie: "Endocrinologie",
      gastroenterologie: "Gastroentérologie",
      infectiologie: "Infectiologie",
      urgences: "Urgences",
      pediatrie: "Pédiatrie",
      gynecologie: "Gynécologie",
      psychiatrie: "Psychiatrie",
      dermatologie: "Dermatologie",
      ophtalmologie: "Ophtalmologie",
      orthopédie: "Orthopédie",
      oncologie: "Oncologie",
      medecine_generale: "Médecine générale"
    },
    service: {
      urgences: "Urgences",
      reanimation: "Réanimation",
      chirurgie: "Chirurgie",
      medecine_interne: "Médecine interne",
      pediatrie: "Pédiatrie",
      maternite: "Maternité",
      consultation: "Consultation",
      oncologie: "Oncologie",
      cardiologie: "Cardiologie",
      neurologie: "Neurologie",
      radiologie: "Radiologie",
      laboratoire: "Laboratoire",
      autre: "Autre"
    },
    accessibility: {
      themeAndAppearance: "Thème et Apparence",
      currentTheme: "Thème actuel",
      fontSize: "Taille du texte",
      size: "Taille",
      small: "Petit",
      normal: "Normal",
      large: "Grand",
      previewText: "Exemple de texte avec la taille sélectionnée. Cette phrase vous permet de prévisualiser l'effet du réglage.",
      contrast: "Contraste",
      contrastHigh: "Élevé",
      contrastHigher: "Très élevé",
      colorVision: "Vision des couleurs",
      auto: "Automatique",
      protanopia: "Protanopie (rouge-vert)",
      deuteranopia: "Deutéranopie (rouge-vert)",
      tritanopia: "Tritanopie (bleu-jaune)",
      motionAndFocus: "Mouvement et Focus",
      animations: "Animations",
      animationsDesc: "Activer les transitions et animations",
      focusIndicator: "Indicateur de focus renforcé",
      focusIndicatorDesc: "Améliore la visibilité du focus pour la navigation au clavier",
      reset: "Réinitialiser les paramètres"
    },
    offlineMode: "Mode hors ligne",
    offlineModeDescription: "Utilisez l'application sans connexion. Gérez le cache et synchronisez vos données.",
    automaticCaching: "Mise en cache automatique",
    automaticCachingDescription: "Mettre automatiquement en cache les contenus pour un accès hors ligne",
    cacheUsage: "Utilisation du cache",
    items: "éléments",
    totalItems: "Éléments totaux",
    storageUsed: "Stockage utilisé",
    cacheManagement: "Gestion du cache",
    refresh: "Actualiser",
    cleanupOld: "Nettoyer les anciens",
    clearing: "Nettoyage...",
    clearAll: "Tout effacer",
    availableOffline: "Contenus disponibles hors ligne",
    flashcards: "Fiches (flashcards)",
    calculators: "Calculateurs",
    recentCases: "Cas récents",
    revisionSheets: "Fiches de révision",
    cacheClearedSuccessfully: "Cache vidé avec succès",
    failedToClearCache: "Échec du nettoyage du cache",
    oldItemsCleaned: "Anciens éléments nettoyés",
    failedToCleanupOldItems: "Échec du nettoyage des anciens éléments",
    checkout: {
      sessionExpired: "Session expirée. Veuillez vous reconnecter.",
      authError: "Erreur d'authentification. Veuillez vous reconnecter.",
      preparing: "Préparation du paiement...",
      paymentError: "Erreur lors de la création du paiement. Veuillez réessayer.",
      redirecting: "Redirection vers Stripe...",
      noUrl: "Erreur: URL de paiement non reçue.",
      checkoutError: "Erreur lors de la création du checkout"
    },
    adminActions: {
      loadUsersError: "Erreur lors du chargement des utilisateurs",
      subscriptionToggled: "Abonnement {{status}} avec succès",
      subscriptionToggleError: "Erreur lors de la modification de l'abonnement",
      fieldUpdated: "{{field}} mis à jour avec succès",
      fieldUpdateError: "Erreur lors de la mise à jour de {{field}}",
      trialExtended: "Période d'essai prolongée de 7 jours",
      trialExtendError: "Erreur lors de la prolongation de l'essai",
      userDeleted: "Utilisateur supprimé avec succès",
      userDeleteError: "Erreur lors de la suppression de l'utilisateur",
      profileLinkCopied: "Lien du profil copié !",
      shareProfile: "Partager mon profil",
      shareProfileDesc: "Partagez votre profil avec vos collègues",
      featureInDev: "Fonctionnalité en développement",
      activePromoCodes: "Codes promo actifs",
      promoCodesDesc: "Gérez les codes de réduction pour vos utilisateurs",
      createCode: "Créer un code",
      refreshData: "Actualiser les données",
      exportStats: "Exporter les stats",
      activated: "activé",
      deactivated: "désactivé"
    },
    newPatient: {
      title: "Nouveau Patient",
      subtitle: "Ajoutez un patient à votre dossier",
      manualEntry: "Saisie manuelle",
      photoCarteVitale: "Photo Carte Vitale",
      patientInfo: "Informations du patient",
      lastName: "Nom",
      firstName: "Prénom",
      lastNamePlaceholder: "Nom de famille",
      firstNamePlaceholder: "Prénom",
      birthDate: "Date de naissance",
      ssn: "Numéro de sécurité sociale",
      phone: "Téléphone",
      email: "Email",
      address: "Adresse",
      addressPlaceholder: "Adresse complète",
      doctor: "Médecin traitant",
      doctorPlaceholder: "Dr. Nom Prénom",
      creating: "Création...",
      createPatient: "Créer le patient",
      cancel: "Annuler",
      verifyInfo: "Vérifiez et complétez les informations",
      created: "Patient créé",
      createdDesc: "{{name}} a été ajouté avec succès",
      createError: "Impossible de créer le patient",
      ocrAutoExtract: "Extraction automatique par photo",
      takeVitalePhoto: "Prenez une photo de la carte Vitale",
      aiAutoExtract: "L'IA extraira automatiquement les informations",
      extracting: "Extraction en cours...",
      choosePhoto: "Choisir une photo",
    },
    notifications: {
      center: "Centre de notifications",
      centerDesc: "Envoyez des emails et notifications push à vos utilisateurs",
      resetStuck: "Reset bloquées",
      resetting: "Reset...",
      noCampaignsStuck: "Aucune campagne bloquée",
      allCampaignsValid: "Toutes les campagnes sont dans un état valide",
      resetError: "Impossible de réinitialiser les campagnes bloquées",
      general: 'Notifications générales', generalDesc: "Activer ou désactiver toutes les notifications de l'application",
      channels: 'Canaux de notification',
      emailNotifs: 'Notifications par email', emailNotifsDesc: 'Recevoir un récapitulatif hebdomadaire et les alertes importantes par email',
      studyReminders: 'Rappels de révision', studyRemindersDesc: 'Recevoir des rappels pour réviser vos flashcards et quiz planifiés',
      communityNotifs: 'Notifications communauté', communityNotifsDesc: 'Recevoir des alertes sur les réponses à vos posts et les mentions',
    },
    pushTest: {
      sendTitle: "Envoyer une Notification Test",
      sendDesc: "Testez l'envoi de notifications push web",
      title: "Titre",
      message: "Message",
      targetUser: "User ID cible (optionnel)",
      targetPlaceholder: "Laisser vide pour envoyer à tous les utilisateurs avec token actif",
      yourId: "Votre ID",
      sending: "Envoi en cours...",
      send: "Envoyer la notification",
      debugInfo: "Informations Debug",
      checkLogs: "Vérifiez les logs dans la console navigateur (F12) et les logs Supabase Edge Functions",
      fieldsRequired: "Champs requis",
      fieldsRequiredDesc: "Le titre et le message sont requis"
    },
    professionalInfo: {
      saved: "Informations professionnelles sauvegardées",
      saveError: "Erreur lors de la sauvegarde des informations professionnelles",
      genericSaveError: "Erreur lors de la sauvegarde",
      title: 'Informations professionnelles',
      description: 'Ces informations sont optionnelles et peuvent être utilisées pour les consultations.',
      phone: 'Téléphone professionnel', email: 'Email professionnel', emailPlaceholder: 'email@etablissement.fr',
      rpps: 'Numéro RPPS', rppsDesc: 'Répertoire Partagé des Professionnels de Santé',
      address: 'Adresse professionnelle', addressPlaceholder: "Adresse de l'établissement",
    },
    onboarding: {
      referralTitle: "Invitez vos collègues ! 🎁",
      referralDesc: "Parrainez un confrère et gagnez 7 jours Premium gratuits.",
      referralButton: "Mon code",
      practiceMode: "Mode d'exercice",
      practiceModeDesc: "Décrivez votre environnement de travail et votre spécialité",
      practiceModeLabel: "Mode d'exercice",
      practiceModePlaceholder: "Sélectionnez votre mode d'exercice",
      specialtyLabel: "Spécialité",
      specialtyPlaceholder: "Sélectionnez votre spécialité",
      serviceTitle: "Service",
      serviceDesc: "Dans quel service exercez-vous principalement ?",
      serviceLabel: "Service",
      servicePlaceholder: "Sélectionnez votre service",
      preferencesTitle: "Préférences",
      preferencesDesc: "Personnalisez votre expérience avec Sclepios",
      notifications: "Notifications",
      notificationsDesc: "Recevez des notifications pour vos flashcards et rappels",
      tips: "Conseils et astuces",
      tipsDesc: "Recevez des conseils pour optimiser votre utilisation",
      newsletter: "Newsletter",
      newsletterDesc: "Recevez notre newsletter mensuelle avec les nouveautés",
      readyTitle: "Prêt à commencer !",
      readyDesc: "Vous êtes maintenant prêt à utiliser toutes les fonctionnalités de Sclepios. Explorez l'IA médicale, créez vos flashcards et améliorez vos connaissances !",
      medicalAI: "IA Médicale",
      community: "Communauté",
      previous: "Précédent",
      skip: "Passer",
      profileRequired: "Profil requis",
      next: "Suivant",
      finishing: "Finalisation...",
      finish: "Terminer",
      fullNamePlaceholder: "Votre nom complet",
      userTypeLabel: "Type d'utilisateur",
      userTypePlaceholder: "Sélectionnez votre profession"
    },
    prompts: {
      title: "Gestion des Prompts Système",
      subtitle: "Gérez les prompts utilisés par l'IA pour chaque spécialité médicale",
      newPrompt: "Nouveau Prompt",
      editPrompt: "Modifier le prompt",
      createPrompt: "Créer un nouveau prompt",
      editDesc: "Modifiez le contenu et les paramètres du prompt",
      createDesc: "Définissez un nouveau prompt pour une spécialité médicale",
      modeLabel: "Mode du prompt *",
      modePlaceholder: "Ex: urgentist, cardiologue, generaliste...",
      modeReadonly: "Le mode ne peut pas être modifié après création",
      contentLabel: "Contenu du prompt *",
      contentPlaceholder: "Décrivez le rôle et les compétences de l'IA pour cette spécialité...",
      activeLabel: "Prompt actif",
      cancel: "Annuler",
      create: "Créer",
      edit: "Modifier",
      active: "Actif",
      inactive: "Inactif",
      usage: "Utilisation",
      location: "Localisation",
      technicalMode: "Mode technique",
      createdOn: "Créé le",
      modifiedOn: "Modifié le",
      confirmDelete: "Confirmer la suppression",
      confirmDeleteDesc: "Êtes-vous sûr de vouloir supprimer le prompt \"{{name}}\" ? Cette action est irréversible.",
      delete: "Supprimer",
      noPrompts: "Aucun prompt système configuré",
      loadError: "Erreur lors du chargement des prompts",
      fillRequired: "Veuillez remplir tous les champs obligatoires",
      created: "Prompt créé avec succès",
      updated: "Prompt modifié avec succès",
      duplicateMode: "Un prompt avec ce mode existe déjà",
      saveError: "Erreur lors de la sauvegarde du prompt",
      deleted: "Prompt supprimé avec succès",
      deleteError: "Erreur lors de la suppression du prompt",
      activated: "Prompt activé avec succès",
      deactivated: "Prompt désactivé avec succès",
      toggleError: "Erreur lors de la modification du statut"
    },
    subscriptionDashboard: {
      title: "Tableau de bord des abonnements",
      subtitle: "Vue d'ensemble des utilisateurs et revenus",
      syncing: "Synchro...",
      resyncSubscribers: "Resync Abonnés",
      syncMRR: "💰 Sync MRR & Coûts",
      step1: "🔄 Étape 1/2 : Synchronisation des abonnés Stripe...",
      step2: "🔄 Étape 2/2 : Vérification des abonnements...",
      syncStripe: "🔄 Synchronisation des montants réels Stripe...",
      syncOpenAI: "🔄 Synchronisation des coûts OpenAI...",
      subscribersSynced: "✅ {{count}} abonnés synchronisés",
      resyncComplete: "✅ Resynchronisation terminée: {{processed}} utilisateurs traités, {{updated}} mis à jour",
      stripeSynced: "✅ Stripe: {{count}} abonnements synchronisés",
      openAISynced: "✅ OpenAI: {{message}}",
      openAIError: "⚠️ Sync OpenAI échouée - Clé API sans permissions 'api.usage.read'",
      mrrUpdated: "💰 MRR mis à jour: {{amount}}€ ({{count}} abonnements)",
      syncError: "Erreur lors de la synchronisation des abonnés Stripe",
      verifyError: "Erreur lors de la vérification des abonnements",
      stripeSyncError: "❌ Erreur lors de la synchronisation Stripe",
      unexpectedError: "Erreur inattendue lors de la synchronisation"
    },
    pushSetup: {
      mobileConfig: 'Configuration Mobile',
      enableDesc: 'Pour une expérience optimale, activez les notifications push sur votre appareil mobile.',
      configSteps: 'Étapes de configuration :',
      step1: 'Cliquez sur "Activer les notifications"',
      step2: 'Autorisez les notifications dans votre navigateur',
      step3: "Ajoutez l'app à votre écran d'accueil (optionnel)",
      activating: 'Activation...',
      enableButton: 'Activer les notifications',
      guide: 'Guide',
      pwaTitle: 'Installation PWA (Progressive Web App) :',
      pwaIos: "• Safari (iOS) : Partager → Ajouter à l'écran d'accueil",
      pwaAndroid: "• Chrome (Android) : Menu → Ajouter à l'écran d'accueil",
      pwaFirefox: '• Firefox : Menu → Installer',
      pwaNote: "L'installation comme PWA améliore les performances et l'expérience des notifications.",
      success: 'Notifications configurées avec succès ! Vous recevrez maintenant des alertes importantes.',
      pushNotifications: 'Notifications Push',
      pushLabel: 'Notifications push',
      pushDesc: "Recevez des alertes pour vos rappels d'étude et notifications importantes",
      browserPermission: 'Permission du navigateur',
      granted: 'Accordée',
      denied: 'Refusée',
      notificationsActive: 'Notifications activées',
      mobileRecommend: 'Les notifications push fonctionnent mieux sur mobile'
    },
    languageUpdated: "Langue mise à jour",
    languageSaveError: "Erreur lors de la sauvegarde de la langue",
    languageChangeError: "Erreur lors du changement de langue",
    emailChange: {
      confirmationInfo: "Un email de confirmation sera envoyé à votre nouvelle adresse. Vous devrez cliquer sur le lien de confirmation pour finaliser le changement.",
      newEmailLabel: "Nouvelle adresse email",
      placeholder: "nouvelle.adresse@exemple.com",
      changeEmail: "Changer mon adresse email",
      confirm: "Confirmer le changement",
    },
    publicProfile: 'Profil public',
  },
  en: {
    title: "Settings",
    tabs: {
      profile: "Profile",
      preferences: "Preferences",
      notifications: "Notifications", 
      billing: "Billing"
    },
    profile: {
      aiPersonalization: "AI Personalization",
      aiPersonalizationDesc: "Customize the AI assistant according to your professional profile",
      changeAvatar: "Change avatar",
      avatarFormats: "Accepted formats: JPG, PNG, GIF (max 5MB)",
      fullName: "Full name",
      email: "Email",
      professionalProfile: "Professional profile",
      practiceMode: "Practice mode",
      specialty: "Specialty",
      service: "Service",
      birthDate: "Date of birth",
      systemRole: "System role",
      systemRoleDesc: "⚠️ System role modification reserved for administrators"
    },
    preferences: {
      title: "Preferences",
      subtitle: "Configure your usage preferences",
      language: "Language",
      theme: "Theme",
      fontSize: "Font size",
      defaultView: "Default view",
      notifications: "Notifications",
      emailNotifications: "Email notifications",
      studyReminders: "Study reminders",
      communityNotifications: "Community notifications",
      keyboardShortcuts: "Keyboard shortcuts",
      keyboardShortcutsDesc: "Enable keyboard shortcuts for faster navigation",
      fontSizes: {
        small: "Small",
        normal: "Normal",
        large: "Large"
      },
      defaultViews: {
        list: "List",
        cards: "Cards",
        grid: "Grid"
      }
    },
    themes: {
      light: "Light",
      dark: "Dark", 
      system: "System"
    },
    save: {
      saveProfile: "Save",
      loadingProfile: "Loading profile...",
      profileSuccess: "Profile updated successfully",
      profileError: "Error updating profile",
      settingsSuccess: "Settings saved",
      settingsError: "Error saving settings",
      notificationsEnabled: "Notifications enabled successfully",
      portalError: "Error opening customer portal"
    },
    subscription: {
      currentPlan: "Current Plan",
      subtitle: "Manage your subscription and billing",
      active: "Active subscription",
      inactive: "Inactive subscription",
      freePremium: "Free Premium",
      plan: "Plan",
      trialMessage: "Trial period ({{days}} days remaining)",
      expiresOn: "Expires on",
      free: "Free",
      manageSubscription: "Manage Subscription",
      manageDescription: "Change your plan, payment method and billing",
      premiumManaged: "Your Premium account is managed by the team. Contact support for any changes.",
      availablePlans: "Available Plans",
      monthlyPlan: "Monthly Plan",
      yearlyPlan: "Yearly Plan",
      popularPlan: "Most Popular",
      savePercent: "Save {{percent}}%",
      features: {
        unlimited: "Unlimited access",
        priority: "Priority support",
        advanced: "Advanced features",
        noAds: "No ads"
      },
      chooseMonthly: "Choose Monthly",
      chooseYearly: "Choose Yearly",
      currentPlanBadge: "Current plan",
      billingHistory: "Billing History",
      noInvoices: "No invoices available",
      invoice: "Invoice",
      amount: "Amount",
      status: "Status",
      date: "Date",
      download: "Download"
    },
    admin: {
      searchUsers: "Search users...",
      refreshUsers: "Refresh",
      totalUsers: "Total users",
      activeUsers: "Active users", 
      premiumUsers: "Premium users",
      trialUsers: "Free trials",
      userManagement: "User Management",
      userManagementDesc: "Manage user accounts, subscriptions and access",
      revenue: "Subscription Revenue (excluding manually activated)",
      aiCosts: "AI Costs (GPT-4.1)",
      netProfit: "Net Profit",
      roiPerUser: "ROI per User",
      avgRoiPerUser: "Average ROI per user (excluding manually activated)",
      legitimatePaidUsers: "Legitimate paid users",
      manuallyActivatedUsers: "Manually activated users",
      legitimateConversionRate: "Legitimate conversion rate",
      quickActions: "Quick actions",
      activeSubscribers: 'Active subscribers', onTrial: 'On trial', trialExpired: 'Trial expired',
    },
    professional: {
      student: "Student",
      intern: "Intern",
      resident: "Resident",
      doctor: "Doctor",
      nurse: "Nurse",
      paramedic: "Paramedic",
      other: "Other"
    },
    role: {
      user: "User",
      moderator: "Moderator",
      admin: "Administrator"
    },
    practiceMode: {
      hospital: "Hospital",
      clinic: "Clinic",
      liberal: "Private practice",
      emergency: "Emergency",
      academic: "Academic",
      other: "Other"
    },
    specialty: {
      cardiologie: "Cardiology",
      pneumologie: "Pulmonology",
      nephrologie: "Nephrology",
      neurologie: "Neurology",
      endocrinologie: "Endocrinology",
      gastroenterologie: "Gastroenterology",
      infectiologie: "Infectious diseases",
      urgences: "Emergency medicine",
      pediatrie: "Pediatrics",
      gynecologie: "Gynecology",
      psychiatrie: "Psychiatry",
      dermatologie: "Dermatology",
      ophtalmologie: "Ophthalmology",
      orthopédie: "Orthopedics",
      oncologie: "Oncology",
      medecine_generale: "General medicine"
    },
    service: {
      urgences: "Emergency",
      reanimation: "Intensive care",
      chirurgie: "Surgery",
      medecine_interne: "Internal medicine",
      pediatrie: "Pediatrics",
      maternite: "Maternity",
      consultation: "Consultation",
      oncologie: "Oncology",
      cardiologie: "Cardiology",
      neurologie: "Neurology",
      radiologie: "Radiology",
      laboratoire: "Laboratory",
      autre: "Other"
    },
    accessibility: {
      themeAndAppearance: "Theme & Appearance",
      currentTheme: "Current theme",
      fontSize: "Text size",
      size: "Size",
      small: "Small",
      normal: "Normal",
      large: "Large",
      previewText: "Sample text with the selected size. This sentence lets you preview the setting effect.",
      contrast: "Contrast",
      contrastHigh: "High",
      contrastHigher: "Very high",
      colorVision: "Color vision",
      auto: "Automatic",
      protanopia: "Protanopia (red-green)",
      deuteranopia: "Deuteranopia (red-green)",
      tritanopia: "Tritanopia (blue-yellow)",
      motionAndFocus: "Motion & Focus",
      animations: "Animations",
      animationsDesc: "Enable transitions and animations",
      focusIndicator: "Enhanced focus indicator",
      focusIndicatorDesc: "Improves focus visibility for keyboard navigation",
      reset: "Reset settings"
    },
    offlineMode: "Offline mode",
    offlineModeDescription: "Use the app without connection. Manage cache and sync your data.",
    automaticCaching: "Automatic caching",
    automaticCachingDescription: "Automatically cache content for offline access",
    cacheUsage: "Cache usage",
    items: "items",
    totalItems: "Total items",
    storageUsed: "Storage used",
    cacheManagement: "Cache management",
    refresh: "Refresh",
    cleanupOld: "Clean up old",
    clearing: "Clearing...",
    clearAll: "Clear all",
    availableOffline: "Available offline content",
    flashcards: "Flashcards",
    calculators: "Calculators",
    recentCases: "Recent cases",
    revisionSheets: "Revision sheets",
    cacheClearedSuccessfully: "Cache cleared successfully",
    failedToClearCache: "Failed to clear cache",
    oldItemsCleaned: "Old items cleaned",
    failedToCleanupOldItems: "Failed to clean up old items",
    checkout: {
      sessionExpired: "Session expired. Please sign in again.",
      authError: "Authentication error. Please sign in again.",
      preparing: "Preparing payment...",
      paymentError: "Error creating payment. Please try again.",
      redirecting: "Redirecting to Stripe...",
      noUrl: "Error: Payment URL not received.",
      checkoutError: "Error creating checkout"
    },
    adminActions: {
      loadUsersError: "Error loading users",
      subscriptionToggled: "Subscription {{status}} successfully",
      subscriptionToggleError: "Error modifying subscription",
      fieldUpdated: "{{field}} updated successfully",
      fieldUpdateError: "Error updating {{field}}",
      trialExtended: "Trial extended by 7 days",
      trialExtendError: "Error extending trial",
      userDeleted: "User deleted successfully",
      userDeleteError: "Error deleting user",
      profileLinkCopied: "Profile link copied!",
      shareProfile: "Share my profile",
      shareProfileDesc: "Share your profile with colleagues",
      featureInDev: "Feature in development",
      activePromoCodes: "Active promo codes",
      promoCodesDesc: "Manage discount codes for your users",
      createCode: "Create code",
      refreshData: "Refresh data",
      exportStats: "Export stats",
      activated: "activated",
      deactivated: "deactivated"
    },
    newPatient: {
      title: "New Patient",
      subtitle: "Add a patient to your records",
      manualEntry: "Manual entry",
      photoCarteVitale: "Health Card Photo",
      patientInfo: "Patient information",
      lastName: "Last name",
      firstName: "First name",
      lastNamePlaceholder: "Last name",
      firstNamePlaceholder: "First name",
      birthDate: "Date of birth",
      ssn: "Social security number",
      phone: "Phone",
      email: "Email",
      address: "Address",
      addressPlaceholder: "Full address",
      doctor: "Primary care physician",
      doctorPlaceholder: "Dr. Last First",
      creating: "Creating...",
      createPatient: "Create patient",
      cancel: "Cancel",
      verifyInfo: "Verify and complete the information",
      created: "Patient created",
      createdDesc: "{{name}} has been added successfully",
      createError: "Unable to create patient",
      ocrAutoExtract: "Auto-extract from photo",
      takeVitalePhoto: "Take a photo of the health card",
      aiAutoExtract: "AI will automatically extract the information",
      extracting: "Extracting...",
      choosePhoto: "Choose a photo",
    },
    notifications: {
      center: "Notification Center",
      centerDesc: "Send emails and push notifications to your users",
      resetStuck: "Reset stuck",
      resetting: "Resetting...",
      noCampaignsStuck: "No stuck campaigns",
      allCampaignsValid: "All campaigns are in a valid state",
      resetError: "Unable to reset stuck campaigns",
      general: 'General notifications', generalDesc: 'Enable or disable all application notifications',
      channels: 'Notification channels',
      emailNotifs: 'Email notifications', emailNotifsDesc: 'Receive weekly summaries and important alerts by email',
      studyReminders: 'Study reminders', studyRemindersDesc: 'Receive reminders to review your flashcards and scheduled quizzes',
      communityNotifs: 'Community notifications', communityNotifsDesc: 'Receive alerts about replies to your posts and mentions',
    },
    pushTest: {
      sendTitle: "Send Test Notification",
      sendDesc: "Test sending web push notifications",
      title: "Title",
      message: "Message",
      targetUser: "Target User ID (optional)",
      targetPlaceholder: "Leave empty to send to all users with active tokens",
      yourId: "Your ID",
      sending: "Sending...",
      send: "Send notification",
      debugInfo: "Debug Information",
      checkLogs: "Check browser console logs (F12) and Supabase Edge Function logs",
      fieldsRequired: "Required fields",
      fieldsRequiredDesc: "Title and message are required"
    },
    professionalInfo: {
      saved: "Professional information saved",
      saveError: "Error saving professional information",
      genericSaveError: "Error saving",
      title: 'Professional Information',
      description: 'This information is optional and can be used for consultations.',
      phone: 'Professional phone', email: 'Professional email', emailPlaceholder: 'email@institution.com',
      rpps: 'RPPS Number', rppsDesc: 'Shared Directory of Healthcare Professionals',
      address: 'Professional address', addressPlaceholder: 'Institution address',
    },
    onboarding: {
      referralTitle: "Invite your colleagues! 🎁",
      referralDesc: "Refer a colleague and earn 7 free Premium days.",
      referralButton: "My code",
      practiceMode: "Practice mode",
      practiceModeDesc: "Describe your work environment and specialty",
      practiceModeLabel: "Practice mode",
      practiceModePlaceholder: "Select your practice mode",
      specialtyLabel: "Specialty",
      specialtyPlaceholder: "Select your specialty",
      serviceTitle: "Department",
      serviceDesc: "In which department do you primarily practice?",
      serviceLabel: "Department",
      servicePlaceholder: "Select your department",
      preferencesTitle: "Preferences",
      preferencesDesc: "Customize your Sclepios experience",
      notifications: "Notifications",
      notificationsDesc: "Receive notifications for your flashcards and reminders",
      tips: "Tips and tricks",
      tipsDesc: "Receive tips to optimize your usage",
      newsletter: "Newsletter",
      newsletterDesc: "Receive our monthly newsletter with updates",
      readyTitle: "Ready to start!",
      readyDesc: "You're now ready to use all Sclepios features. Explore medical AI, create flashcards and improve your knowledge!",
      medicalAI: "Medical AI",
      community: "Community",
      previous: "Previous",
      skip: "Skip",
      profileRequired: "Profile required",
      next: "Next",
      finishing: "Finishing...",
      finish: "Finish",
      fullNamePlaceholder: "Your full name",
      userTypeLabel: "User type",
      userTypePlaceholder: "Select your profession"
    },
    prompts: {
      title: "System Prompts Management",
      subtitle: "Manage prompts used by AI for each medical specialty",
      newPrompt: "New Prompt",
      editPrompt: "Edit prompt",
      createPrompt: "Create a new prompt",
      editDesc: "Edit the content and parameters of the prompt",
      createDesc: "Define a new prompt for a medical specialty",
      modeLabel: "Prompt mode *",
      modePlaceholder: "E.g.: urgentist, cardiologist, generalist...",
      modeReadonly: "Mode cannot be changed after creation",
      contentLabel: "Prompt content *",
      contentPlaceholder: "Describe the AI's role and skills for this specialty...",
      activeLabel: "Active prompt",
      cancel: "Cancel",
      create: "Create",
      edit: "Edit",
      active: "Active",
      inactive: "Inactive",
      usage: "Usage",
      location: "Location",
      technicalMode: "Technical mode",
      createdOn: "Created on",
      modifiedOn: "Modified on",
      confirmDelete: "Confirm deletion",
      confirmDeleteDesc: "Are you sure you want to delete the prompt \"{{name}}\"? This action is irreversible.",
      delete: "Delete",
      noPrompts: "No system prompts configured",
      loadError: "Error loading prompts",
      fillRequired: "Please fill in all required fields",
      created: "Prompt created successfully",
      updated: "Prompt updated successfully",
      duplicateMode: "A prompt with this mode already exists",
      saveError: "Error saving prompt",
      deleted: "Prompt deleted successfully",
      deleteError: "Error deleting prompt",
      activated: "Prompt activated successfully",
      deactivated: "Prompt deactivated successfully",
      toggleError: "Error changing prompt status"
    },
    subscriptionDashboard: {
      title: "Subscription Dashboard",
      subtitle: "Overview of users and revenue",
      syncing: "Syncing...",
      resyncSubscribers: "Resync Subscribers",
      syncMRR: "💰 Sync MRR & Costs",
      step1: "🔄 Step 1/2: Syncing Stripe subscribers...",
      step2: "🔄 Step 2/2: Verifying subscriptions...",
      syncStripe: "🔄 Syncing actual Stripe amounts...",
      syncOpenAI: "🔄 Syncing OpenAI costs...",
      subscribersSynced: "✅ {{count}} subscribers synced",
      resyncComplete: "✅ Resync complete: {{processed}} users processed, {{updated}} updated",
      stripeSynced: "✅ Stripe: {{count}} subscriptions synced",
      openAISynced: "✅ OpenAI: {{message}}",
      openAIError: "⚠️ OpenAI sync failed - API key without 'api.usage.read' permissions",
      mrrUpdated: "💰 MRR updated: €{{amount}} ({{count}} subscriptions)",
      syncError: "Error syncing Stripe subscribers",
      verifyError: "Error verifying subscriptions",
      stripeSyncError: "❌ Error syncing Stripe",
      unexpectedError: "Unexpected error during synchronization"
    },
    pushSetup: {
      mobileConfig: 'Mobile Setup',
      enableDesc: 'For an optimal experience, enable push notifications on your mobile device.',
      configSteps: 'Setup steps:',
      step1: 'Click "Enable notifications"',
      step2: 'Allow notifications in your browser',
      step3: 'Add the app to your home screen (optional)',
      activating: 'Activating...',
      enableButton: 'Enable notifications',
      guide: 'Guide',
      pwaTitle: 'PWA Installation (Progressive Web App):',
      pwaIos: '• Safari (iOS): Share → Add to Home Screen',
      pwaAndroid: '• Chrome (Android): Menu → Add to Home Screen',
      pwaFirefox: '• Firefox: Menu → Install',
      pwaNote: 'Installing as a PWA improves performance and notification experience.',
      success: 'Notifications configured successfully! You will now receive important alerts.',
      pushNotifications: 'Push Notifications',
      pushLabel: 'Push notifications',
      pushDesc: 'Receive alerts for your study reminders and important notifications',
      browserPermission: 'Browser permission',
      granted: 'Granted',
      denied: 'Denied',
      notificationsActive: 'Notifications enabled',
      mobileRecommend: 'Push notifications work best on mobile'
    },
    languageUpdated: "Language updated",
    languageSaveError: "Error saving language preference",
    languageChangeError: "Error changing language",
    emailChange: {
      confirmationInfo: "A confirmation email will be sent to your new address. You will need to click the confirmation link to finalize the change.",
      newEmailLabel: "New email address",
      placeholder: "new.address@example.com",
      changeEmail: "Change my email address",
      confirm: "Confirm change",
    },
    publicProfile: 'Public profile',
  },
  es: {
    title: "Configuración",
    tabs: {
      profile: "Perfil",
      preferences: "Preferencias",
      notifications: "Notificaciones",
      billing: "Facturación"
    },
    profile: {
      aiPersonalization: "Personalización IA",
      aiPersonalizationDesc: "Personaliza el asistente IA según tu perfil profesional",
      changeAvatar: "Cambiar avatar",
      avatarFormats: "Formatos aceptados: JPG, PNG, GIF (máx 5MB)",
      fullName: "Nombre completo",
      email: "Email",
      professionalProfile: "Perfil profesional",
      practiceMode: "Modo de ejercicio",
      specialty: "Especialidad",
      service: "Servicio",
      birthDate: "Fecha de nacimiento",
      systemRole: "Rol del sistema",
      systemRoleDesc: "⚠️ Modificación del rol del sistema reservada para administradores"
    },
    preferences: {
      title: "Preferencias",
      subtitle: "Configura tus preferencias de uso",
      language: "Idioma",
      theme: "Tema",
      fontSize: "Tamaño de fuente",
      defaultView: "Vista predeterminada",
      notifications: "Notificaciones",
      emailNotifications: "Notificaciones por email",
      studyReminders: "Recordatorios de estudio",
      communityNotifications: "Notificaciones de la comunidad",
      keyboardShortcuts: "Atajos de teclado",
      keyboardShortcutsDesc: "Habilitar atajos de teclado para navegación más rápida",
      fontSizes: {
        small: "Pequeño",
        normal: "Normal",
        large: "Grande"
      },
      defaultViews: {
        list: "Lista",
        cards: "Tarjetas",
        grid: "Cuadrícula"
      }
    },
    themes: {
      light: "Claro",
      dark: "Oscuro",
      system: "Sistema"
    },
    save: {
      saveProfile: "Guardar",
      loadingProfile: "Cargando perfil...",
      profileSuccess: "Perfil actualizado exitosamente",
      profileError: "Error al actualizar el perfil",
      settingsSuccess: "Configuración guardada",
      settingsError: "Error al guardar la configuración",
      notificationsEnabled: "Notificaciones activadas exitosamente",
      portalError: "Error al abrir el portal del cliente"
    },
    subscription: {
      currentPlan: "Plan Actual",
      subtitle: "Gestiona tu suscripción y facturación",
      active: "Suscripción activa",
      inactive: "Suscripción inactiva",
      freePremium: "Premium gratuito",
      plan: "Plan",
      trialMessage: "Período de prueba ({{days}} días restantes)",
      expiresOn: "Expira el",
      free: "Gratuito",
      manageSubscription: "Gestionar Suscripción",
      manageDescription: "Cambiar tu plan, método de pago y facturación",
      premiumManaged: "Tu cuenta Premium es gestionada por el equipo. Contacta al soporte para cualquier cambio.",
      availablePlans: "Planes Disponibles",
      monthlyPlan: "Plan Mensual",
      yearlyPlan: "Plan Anual",
      popularPlan: "Más Popular",
      savePercent: "Ahorra {{percent}}%",
      features: {
        unlimited: "Acceso ilimitado",
        priority: "Soporte prioritario",
        advanced: "Funcionalidades avanzadas",
        noAds: "Sin anuncios"
      },
      chooseMonthly: "Elegir Mensual",
      chooseYearly: "Elegir Anual",
      currentPlanBadge: "Plan actual",
      billingHistory: "Historial de Facturación",
      noInvoices: "No hay facturas disponibles",
      invoice: "Factura",
      amount: "Monto",
      status: "Estado",
      date: "Fecha",
      download: "Descargar"
    },
    admin: {
      searchUsers: "Buscar usuarios...",
      refreshUsers: "Actualizar",
      totalUsers: "Total usuarios",
      activeUsers: "Usuarios activos", 
      premiumUsers: "Usuarios premium",
      trialUsers: "Pruebas gratuitas",
      userManagement: "Gestión de usuarios",
      userManagementDesc: "Gestiona las cuentas de usuario, suscripciones y acceso",
      revenue: "Ingresos por Suscripción (excluyendo activados manualmente)",
      aiCosts: "Costos IA (GPT-4.1)",
      netProfit: "Beneficio Neto",
      roiPerUser: "ROI por Usuario",
      avgRoiPerUser: "ROI promedio por usuario (excluyendo activados manualmente)",
      legitimatePaidUsers: "Usuarios de pago legítimos",
      manuallyActivatedUsers: "Usuarios activados manualmente",
      legitimateConversionRate: "Tasa de conversión legítima",
      quickActions: "Acciones rápidas",
      activeSubscribers: 'Suscriptores activos', onTrial: 'En prueba', trialExpired: 'Prueba expirada',
    },
    professional: {
      student: "Estudiante",
      intern: "Interno",
      resident: "Residente",
      doctor: "Doctor",
      nurse: "Enfermero",
      paramedic: "Paramédico",
      other: "Otro"
    },
    role: {
      user: "Usuario",
      moderator: "Moderador",
      admin: "Administrador"
    },
    practiceMode: {
      hospital: "Hospital",
      clinic: "Clínica",
      liberal: "Práctica privada",
      emergency: "Emergencia",
      academic: "Académico",
      other: "Otro"
    },
    specialty: {
      cardiologie: "Cardiología",
      pneumologie: "Neumología",
      nephrologie: "Nefrología",
      neurologie: "Neurología",
      endocrinologie: "Endocrinología",
      gastroenterologie: "Gastroenterología",
      infectiologie: "Enfermedades infecciosas",
      urgences: "Medicina de urgencias",
      pediatrie: "Pediatría",
      gynecologie: "Ginecología",
      psychiatrie: "Psiquiatría",
      dermatologie: "Dermatología",
      ophtalmologie: "Oftalmología",
      orthopédie: "Ortopedia",
      oncologie: "Oncología",
      medecine_generale: "Medicina general"
    },
    service: {
      urgences: "Urgencias",
      reanimation: "Cuidados intensivos",
      chirurgie: "Cirugía",
      medecine_interne: "Medicina interna",
      pediatrie: "Pediatría",
      maternite: "Maternidad",
      consultation: "Consulta",
      oncologie: "Oncología",
      cardiologie: "Cardiología",
      neurologie: "Neurología",
      radiologie: "Radiología",
      laboratoire: "Laboratorio",
      autre: "Otro"
    },
    accessibility: {
      themeAndAppearance: "Tema y Apariencia",
      currentTheme: "Tema actual",
      fontSize: "Tamaño del texto",
      size: "Tamaño",
      small: "Pequeño",
      normal: "Normal",
      large: "Grande",
      previewText: "Texto de ejemplo con el tamaño seleccionado. Esta frase le permite previsualizar el efecto del ajuste.",
      contrast: "Contraste",
      contrastHigh: "Alto",
      contrastHigher: "Muy alto",
      colorVision: "Visión de colores",
      auto: "Automático",
      protanopia: "Protanopía (rojo-verde)",
      deuteranopia: "Deuteranopía (rojo-verde)",
      tritanopia: "Tritanopía (azul-amarillo)",
      motionAndFocus: "Movimiento y Focus",
      animations: "Animaciones",
      animationsDesc: "Activar transiciones y animaciones",
      focusIndicator: "Indicador de focus mejorado",
      focusIndicatorDesc: "Mejora la visibilidad del focus para navegación con teclado",
      reset: "Restablecer configuración"
    },
    offlineMode: "Modo sin conexión",
    offlineModeDescription: "Usa la app sin conexión. Gestiona la caché y sincroniza tus datos.",
    automaticCaching: "Caché automática",
    automaticCachingDescription: "Guardar contenido automáticamente para acceso sin conexión",
    cacheUsage: "Uso de la caché",
    items: "elementos",
    totalItems: "Elementos totales",
    storageUsed: "Almacenamiento usado",
    cacheManagement: "Gestión de la caché",
    refresh: "Actualizar",
    cleanupOld: "Limpiar antiguos",
    clearing: "Limpiando...",
    clearAll: "Borrar todo",
    availableOffline: "Contenido disponible sin conexión",
    flashcards: "Tarjetas",
    calculators: "Calculadoras",
    recentCases: "Casos recientes",
    revisionSheets: "Hojas de revisión",
    cacheClearedSuccessfully: "Caché borrada con éxito",
    failedToClearCache: "Error al borrar la caché",
    oldItemsCleaned: "Elementos antiguos limpiados",
    failedToCleanupOldItems: "Error al limpiar elementos antiguos",
    checkout: {
      sessionExpired: "Sesión expirada. Por favor inicie sesión de nuevo.",
      authError: "Error de autenticación. Por favor inicie sesión de nuevo.",
      preparing: "Preparando el pago...",
      paymentError: "Error al crear el pago. Por favor intente de nuevo.",
      redirecting: "Redirigiendo a Stripe...",
      noUrl: "Error: URL de pago no recibida.",
      checkoutError: "Error al crear el checkout"
    },
    adminActions: {
      loadUsersError: "Error al cargar usuarios",
      subscriptionToggled: "Suscripción {{status}} exitosamente",
      subscriptionToggleError: "Error al modificar la suscripción",
      fieldUpdated: "{{field}} actualizado exitosamente",
      fieldUpdateError: "Error al actualizar {{field}}",
      trialExtended: "Prueba extendida por 7 días",
      trialExtendError: "Error al extender la prueba",
      userDeleted: "Usuario eliminado exitosamente",
      userDeleteError: "Error al eliminar usuario",
      profileLinkCopied: "¡Enlace del perfil copiado!",
      shareProfile: "Compartir mi perfil",
      shareProfileDesc: "Comparte tu perfil con colegas",
      featureInDev: "Función en desarrollo",
      activePromoCodes: "Códigos promo activos",
      promoCodesDesc: "Gestione códigos de descuento para sus usuarios",
      createCode: "Crear código",
      refreshData: "Actualizar datos",
      exportStats: "Exportar estadísticas",
      activated: "activada",
      deactivated: "desactivada"
    },
    newPatient: {
      title: "Nuevo Paciente",
      subtitle: "Agregue un paciente a su expediente",
      manualEntry: "Entrada manual",
      photoCarteVitale: "Foto Tarjeta Sanitaria",
      patientInfo: "Información del paciente",
      lastName: "Apellido",
      firstName: "Nombre",
      lastNamePlaceholder: "Apellido",
      firstNamePlaceholder: "Nombre",
      birthDate: "Fecha de nacimiento",
      ssn: "Número de seguridad social",
      phone: "Teléfono",
      email: "Email",
      address: "Dirección",
      addressPlaceholder: "Dirección completa",
      doctor: "Médico de cabecera",
      doctorPlaceholder: "Dr. Apellido Nombre",
      creating: "Creando...",
      createPatient: "Crear paciente",
      cancel: "Cancelar",
      verifyInfo: "Verifique y complete la información",
      created: "Paciente creado",
      createdDesc: "{{name}} ha sido agregado exitosamente",
      createError: "No se pudo crear el paciente",
      ocrAutoExtract: "Extracción automática por foto",
      takeVitalePhoto: "Tome una foto de la tarjeta sanitaria",
      aiAutoExtract: "La IA extraerá automáticamente la información",
      extracting: "Extrayendo...",
      choosePhoto: "Elegir una foto",
    },
    notifications: {
      center: "Centro de notificaciones",
      centerDesc: "Envíe emails y notificaciones push a sus usuarios",
      resetStuck: "Reset bloqueadas",
      resetting: "Reseteando...",
      noCampaignsStuck: "Ninguna campaña bloqueada",
      allCampaignsValid: "Todas las campañas están en estado válido",
      resetError: "No se pudieron resetear las campañas bloqueadas",
      general: 'Notificaciones generales', generalDesc: 'Activar o desactivar todas las notificaciones de la aplicación',
      channels: 'Canales de notificación',
      emailNotifs: 'Notificaciones por email', emailNotifsDesc: 'Recibir un resumen semanal y las alertas importantes por email',
      studyReminders: 'Recordatorios de estudio', studyRemindersDesc: 'Recibir recordatorios para revisar tus tarjetas y cuestionarios planificados',
      communityNotifs: 'Notificaciones de comunidad', communityNotifsDesc: 'Recibir alertas sobre las respuestas a tus posts y menciones',
    },
    pushTest: {
      sendTitle: "Enviar Notificación de Prueba",
      sendDesc: "Pruebe el envío de notificaciones push web",
      title: "Título",
      message: "Mensaje",
      targetUser: "ID de usuario objetivo (opcional)",
      targetPlaceholder: "Dejar vacío para enviar a todos los usuarios con tokens activos",
      yourId: "Su ID",
      sending: "Enviando...",
      send: "Enviar notificación",
      debugInfo: "Información de Debug",
      checkLogs: "Verifique los logs en la consola del navegador (F12) y los logs de Supabase Edge Functions",
      fieldsRequired: "Campos requeridos",
      fieldsRequiredDesc: "El título y el mensaje son requeridos"
    },
    professionalInfo: {
      saved: "Información profesional guardada",
      saveError: "Error al guardar la información profesional",
      genericSaveError: "Error al guardar",
      title: 'Información profesional',
      description: 'Esta información es opcional y puede ser utilizada para las consultas.',
      phone: 'Teléfono profesional', email: 'Email profesional', emailPlaceholder: 'email@establecimiento.com',
      rpps: 'Número RPPS', rppsDesc: 'Directorio Compartido de Profesionales de Salud',
      address: 'Dirección profesional', addressPlaceholder: 'Dirección del establecimiento',
    },
    onboarding: {
      referralTitle: "¡Invita a tus colegas! 🎁",
      referralDesc: "Refiere a un colega y gana 7 días Premium gratis.",
      referralButton: "Mi código",
      practiceMode: "Modo de ejercicio",
      practiceModeDesc: "Describe tu entorno de trabajo y tu especialidad",
      practiceModeLabel: "Modo de ejercicio",
      practiceModePlaceholder: "Selecciona tu modo de ejercicio",
      specialtyLabel: "Especialidad",
      specialtyPlaceholder: "Selecciona tu especialidad",
      serviceTitle: "Servicio",
      serviceDesc: "¿En qué servicio ejerces principalmente?",
      serviceLabel: "Servicio",
      servicePlaceholder: "Selecciona tu servicio",
      preferencesTitle: "Preferencias",
      preferencesDesc: "Personaliza tu experiencia con Sclepios",
      notifications: "Notificaciones",
      notificationsDesc: "Recibe notificaciones para tus flashcards y recordatorios",
      tips: "Consejos y trucos",
      tipsDesc: "Recibe consejos para optimizar tu uso",
      newsletter: "Newsletter",
      newsletterDesc: "Recibe nuestro boletín mensual con novedades",
      readyTitle: "¡Listo para empezar!",
      readyDesc: "Ya estás listo para usar todas las funciones de Sclepios. ¡Explora la IA médica, crea flashcards y mejora tus conocimientos!",
      medicalAI: "IA Médica",
      community: "Comunidad",
      previous: "Anterior",
      skip: "Omitir",
      profileRequired: "Perfil requerido",
      next: "Siguiente",
      finishing: "Finalizando...",
      finish: "Finalizar",
      fullNamePlaceholder: "Tu nombre completo",
      userTypeLabel: "Tipo de usuario",
      userTypePlaceholder: "Selecciona tu profesión"
    },
    prompts: {
      title: "Gestión de Prompts del Sistema",
      subtitle: "Gestiona los prompts utilizados por la IA para cada especialidad médica",
      newPrompt: "Nuevo Prompt",
      editPrompt: "Editar prompt",
      createPrompt: "Crear un nuevo prompt",
      editDesc: "Edita el contenido y los parámetros del prompt",
      createDesc: "Define un nuevo prompt para una especialidad médica",
      modeLabel: "Modo del prompt *",
      modePlaceholder: "Ej: urgentista, cardiólogo, generalista...",
      modeReadonly: "El modo no se puede cambiar después de la creación",
      contentLabel: "Contenido del prompt *",
      contentPlaceholder: "Describe el rol y las habilidades de la IA para esta especialidad...",
      activeLabel: "Prompt activo",
      cancel: "Cancelar",
      create: "Crear",
      edit: "Editar",
      active: "Activo",
      inactive: "Inactivo",
      usage: "Uso",
      location: "Ubicación",
      technicalMode: "Modo técnico",
      createdOn: "Creado el",
      modifiedOn: "Modificado el",
      confirmDelete: "Confirmar eliminación",
      confirmDeleteDesc: "¿Está seguro de que desea eliminar el prompt \"{{name}}\"? Esta acción es irreversible.",
      delete: "Eliminar",
      noPrompts: "No hay prompts del sistema configurados",
      loadError: "Error al cargar los prompts",
      fillRequired: "Por favor complete todos los campos obligatorios",
      created: "Prompt creado exitosamente",
      updated: "Prompt actualizado exitosamente",
      duplicateMode: "Ya existe un prompt con este modo",
      saveError: "Error al guardar el prompt",
      deleted: "Prompt eliminado exitosamente",
      deleteError: "Error al eliminar el prompt",
      activated: "Prompt activado exitosamente",
      deactivated: "Prompt desactivado exitosamente",
      toggleError: "Error al cambiar el estado del prompt"
    },
    subscriptionDashboard: {
      title: "Panel de suscripciones",
      subtitle: "Resumen de usuarios e ingresos",
      syncing: "Sincronizando...",
      resyncSubscribers: "Resync Suscriptores",
      syncMRR: "💰 Sync MRR y Costos",
      step1: "🔄 Paso 1/2: Sincronizando suscriptores Stripe...",
      step2: "🔄 Paso 2/2: Verificando suscripciones...",
      syncStripe: "🔄 Sincronizando montos reales de Stripe...",
      syncOpenAI: "🔄 Sincronizando costos de OpenAI...",
      subscribersSynced: "✅ {{count}} suscriptores sincronizados",
      resyncComplete: "✅ Resincronización completa: {{processed}} usuarios procesados, {{updated}} actualizados",
      stripeSynced: "✅ Stripe: {{count}} suscripciones sincronizadas",
      openAISynced: "✅ OpenAI: {{message}}",
      openAIError: "⚠️ Sync OpenAI fallido - Clave API sin permisos 'api.usage.read'",
      mrrUpdated: "💰 MRR actualizado: {{amount}}€ ({{count}} suscripciones)",
      syncError: "Error al sincronizar suscriptores Stripe",
      verifyError: "Error al verificar suscripciones",
      stripeSyncError: "❌ Error al sincronizar Stripe",
      unexpectedError: "Error inesperado durante la sincronización"
    },
    pushSetup: {
      mobileConfig: 'Configuración Móvil',
      enableDesc: 'Para una experiencia óptima, active las notificaciones push en su dispositivo móvil.',
      configSteps: 'Pasos de configuración:',
      step1: 'Haga clic en "Activar notificaciones"',
      step2: 'Autorice las notificaciones en su navegador',
      step3: 'Agregue la app a su pantalla de inicio (opcional)',
      activating: 'Activando...',
      enableButton: 'Activar notificaciones',
      guide: 'Guía',
      pwaTitle: 'Instalación PWA (Progressive Web App):',
      pwaIos: '• Safari (iOS): Compartir → Agregar a pantalla de inicio',
      pwaAndroid: '• Chrome (Android): Menú → Agregar a pantalla de inicio',
      pwaFirefox: '• Firefox: Menú → Instalar',
      pwaNote: 'La instalación como PWA mejora el rendimiento y la experiencia de notificaciones.',
      success: '¡Notificaciones configuradas con éxito! Ahora recibirá alertas importantes.',
      pushNotifications: 'Notificaciones Push',
      pushLabel: 'Notificaciones push',
      pushDesc: 'Reciba alertas para sus recordatorios de estudio y notificaciones importantes',
      browserPermission: 'Permiso del navegador',
      granted: 'Concedido',
      denied: 'Denegado',
      notificationsActive: 'Notificaciones activadas',
      mobileRecommend: 'Las notificaciones push funcionan mejor en móvil'
    },
    languageUpdated: "Idioma actualizado",
    languageSaveError: "Error al guardar preferencia de idioma",
    languageChangeError: "Error al cambiar idioma",
    emailChange: {
      confirmationInfo: "Se enviará un correo de confirmación a su nueva dirección. Deberá hacer clic en el enlace de confirmación para finalizar el cambio.",
      newEmailLabel: "Nueva dirección de correo",
      placeholder: "nueva.direccion@ejemplo.com",
      changeEmail: "Cambiar mi dirección de correo",
      confirm: "Confirmar cambio",
    },
    publicProfile: 'Perfil público',
  }
};